module.exports = __webpack_public_path__ + "static/media/45_A.9dd70f28.png";